import axios from 'axios'
import request from './request'

interface DeleteParams {
  id: number
}

interface DeleteResponse {
  code: number
  msg: string
  data?: unknown
}


export function deleteChecklistItem(params: DeleteParams): Promise<DeleteResponse> {
  return request.post('/api/admin/checklist/delete', params)
}
